import { apiGet, apiPost, apiPut } from './api';

/**
 * API client for a referral's Medical Records Request lifecycle.
 *
 * The backend exposes a singleton sub-resource keyed by the referral's
 * legacy id (the user-known integer, mirrored onto Referral.legacy_referral_id):
 *
 *   GET    /api/v1/referrals/<legacy_referral_id>/medical-records/
 *   POST   /api/v1/referrals/<legacy_referral_id>/medical-records/
 *   PUT    /api/v1/referrals/<legacy_referral_id>/medical-records/
 *
 * GET returns the page payload `{ referral_context, medical_records }` where
 * `medical_records` is null when no record exists yet (empty state). POST and
 * PUT return the serialized `medical_records` record itself.
 */

const medicalRecordsUrl = (legacyReferralId) =>
  `/api/v1/referrals/${legacyReferralId}/medical-records/`;

/**
 * Fetch the medical-records page payload for a referral.
 * @returns {Promise<{referral_context: object, medical_records: object|null}>}
 */
export const fetchMedicalRecords = async (legacyReferralId) =>
  apiGet(medicalRecordsUrl(legacyReferralId));

/**
 * Create the medical-records request for a referral. Use when the GET payload
 * returned `medical_records: null`.
 * @returns {Promise<object>} the created record
 */
export const createMedicalRecords = async (legacyReferralId, payload) =>
  apiPost(medicalRecordsUrl(legacyReferralId), payload);

/**
 * Update the existing medical-records request for a referral.
 * @returns {Promise<object>} the updated record
 */
export const updateMedicalRecords = async (legacyReferralId, payload) =>
  apiPut(medicalRecordsUrl(legacyReferralId), payload);
